<template>
  <div class="animated--grow-in"
       style="min-height: 100vh;
                z-index: 999999;
                background: #f4f4f4;
                min-width: 100%;
                overflow-y: auto;
                overflow-x: hidden;
                position: fixed;">
    <div class="row pt-3 px-3">

      <div class="col-12 d-flex px-2 py-4 mb-3 justify-content-between"
           style="height: 65px;">
        <div class="pl-3 d-block">
          <strong class="title-color">
            {{ (me.data.name ? me.data.name : '---') | truncate(20) }}
          </strong>
          <div>
            <small>{{ (me.data.email ? me.data.email : '---') | truncate(25) }}</small>
          </div>
        </div>
        <div class="pr-2" @click.prevent="closeMenu()">
          <i class="bx bx-x bx-sm"></i>
        </div>
      </div>

      <div class="col-12 px-4 pb-4"
           style="height: calc(100vh - 65px)">
        <div class="row pb-4">
          <div class="col text-center">
            <div @click="setUser" class="btn btn-outline-dark d-block rounded-0">
              <i class="bx bxs-user pr-2"></i>
              <small>{{ getTranslations('expression_40') }}</small>
            </div>
          </div>
          <div v-if="me.data.role_key > 0" class="col text-center">
            <div @click="goRouter('Channels')" class="btn btn-outline-dark d-block rounded-0">
              <i class="bx bx-sitemap pr-2"></i>
              <small>{{ getTranslations('expression_5') }}</small>
            </div>
          </div>
          <div v-else class="col text-center">
            <div @click="goRouter('Chat')" class="btn btn-outline-dark d-block rounded-0">
              <i class="bx bxs-chat pr-2"></i>
              <small>{{ getTranslations('expression_312') }}</small>
            </div>
          </div>
        </div>
        <div class="pb-4 pt-1">
          <ul class="list-group ellipsis  shadow-sm"  style="min-width: 100%;">
            <div @click="goRouter('Home')"
                 :class="{'list_hover_active' : this.$route.name === 'Home'}"
                 class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bx-tachometer pr-3"></i>
                <span class="ellipsis">
                {{ getTranslations('expression_11') }}
              </span>
              </div>
              <i v-if="this.$route.name === 'Home'"
                 class="animated--grow-in bx bx-chevron-right "></i>
            </div>

          <div @click="goRouter('Kanban')"
               :class="{'list_hover_active' : this.$route.name === 'Kanban'}"
               class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
            <div class="d-flex align-items-center">
              <i class='bx bxs-dashboard pr-3'></i>
              <span class="ellipsis">
                Kanban
              </span>
            </div>
            <i v-if="this.$route.name === 'Kanban'"
               class="animated--grow-in bx bx-chevron-right"></i>
          </div>

          <div @click="goRouter('Gallery')" 
                :class="{'list_hover_active' : this.$route.name === 'Gallery'}"
                class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bx-photo-album pr-3"></i>
                <!-- <span class="ellipsis">{{ getTranslations('expression_69') }}</span> -->
                <span class="ellipsis">Galeria</span>
              </div>
              <i v-if="this.$route.name === 'Gallery'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </div>

          <div @click="goRouter('Activities')" 
                :class="{'list_hover_active' : this.$route.name === 'Activities'}"
                class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bx-task pr-3"></i>
                <span class="ellipsis">{{ getTranslations('expression_69') }}</span>
              </div>
              <i v-if="this.$route.name === 'Activities'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </div>

            <div @click="goRouter('Leads')"
                 :class="{'list_hover_active' : this.$route.name === 'Leads' || this.$route.name === 'Lead'}"
                 class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bxs-user-plus bx-xs pr-3"></i>
                <span class="ellipsis">{{ getTranslations('expression_35') }}</span>
              </div>
              <i v-if="this.$route.name === 'Leads' || this.$route.name === 'Lead'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div @click="goRouter('Campaigns')"
                 v-if="me.data.role_key > 0"
                 @click.stop=""
                 :class="{'list_hover_active' : this.$route.name === 'Campaigns' || this.$route.name === 'Campaign'}"
                 class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bx-rocket pr-3"></i>
                <span class="ellipsis">{{ getTranslations('expression_3') }}</span>
              </div>
              <i v-if="this.$route.name === 'Campaigns' || this.$route.name === 'Campaign'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <!-- RELATORIOS-->
            <div @click.prevent="setDropdown(1)"
                 :class="{'list_hover_active' : $route.name === 'ReportsTickets' ||
                                              $route.name === 'ReportsCampaigns' ||
                                              $route.name === 'ReportsOperatorsLeads' ||
                                              $route.name === 'ReportsSources' ||
                                              $route.name === 'ReportsEmail' ||
                                              $route.name === 'ReportsHsm' ||
                                              $route.name === 'ReportsSms' ||
                                              $route.name === 'ReportsNps' ||
                                              $route.name === 'ReportsVoip'}"
                 class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bx-chart pr-3"></i>
                <span class="ellipsis">{{ getTranslations('expression_59') }}</span>
              </div>
              <i v-if="dropdown === 1"
                 class="animated--grow-in bx bx-chevron-down bx-xs"></i>
            </div>
            <!-- SUBMENU - RELATORIOS -->
            <div v-if="dropdown === 1 && me.data.role_key > 0"
                 @click="goRouter('ReportsCampaigns')"
                 :class="{'list_hover_active' : this.$route.name === 'ReportsCampaigns'}"
                 class="animated--fade-in list-group-item list_hover border-bottom-0 pt-4 cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
              {{ getTranslations('expression_103') }}
            </span>
              <i v-if="this.$route.name === 'ReportsCampaigns'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div  v-if="dropdown === 1 && me.data.role_key > 0"
                  @click="goRouter('ReportsEmail')"
                  :class="{'list_hover_active' : this.$route.name === 'ReportsEmail'}"
                  class="animated--fade-in list-group-item list_hover border-bottom-0 cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
              {{ getTranslations('expression_1038') }}
            </span>
              <i v-if="this.$route.name === 'ReportsEmail'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div  v-if="dropdown === 1 && me.data.role_key > 0"
                  @click="goRouter('ReportsHsm')"
                  :class="{'list_hover_active' : this.$route.name === 'ReportsHsm'}"
                  class="animated--fade-in list-group-item list_hover border-bottom-0 cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
              {{ getTranslations('expression_1039') }}
            </span>
              <i v-if="this.$route.name === 'ReportsHsm'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div  v-if="dropdown === 1 && me.data.role_key > 0"
                  @click="goRouter('ReportsOperatorsLeads')"
                  :class="{'list_hover_active' : this.$route.name === 'ReportsOperatorsLeads'}"
                  class="animated--fade-in list-group-item list_hover border-bottom-0 cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
              {{ getTranslations('expression_105') }}
            </span>
              <i v-if="this.$route.name === 'ReportsOperatorsLeads'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div v-if="dropdown === 1 && me.data.role_key > 0"
                 @click="goRouter('ReportsSms')"
                 :class="{'list_hover_active' : this.$route.name === 'ReportsSms'}"
                 class="animated--fade-in list-group-item list_hover border-bottom-0 cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
              {{ getTranslations('expression_1040') }}
            </span>
              <i v-if="this.$route.name === 'ReportsSms'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div  v-if="dropdown === 1 && me.data.role_key > 0"
                  @click="goRouter('ReportsVoip')"
                  :class="{'list_hover_active' : this.$route.name === 'ReportsVoip'}"
                  class="animated--fade-in list-group-item list_hover border-bottom-0 cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
              {{ getTranslations('expression_1041') }}
            </span>
              <i v-if="this.$route.name === 'ReportsVoip'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div  v-if="dropdown === 1 && me.data.role_key > 0"
                  @click="goRouter('ReportsNps')"
                  :class="{'list_hover_active' : this.$route.name === 'ReportsNps'}"
                  class="animated--fade-in list-group-item list_hover border-bottom-0 cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
              {{ getTranslations('expression_1052') | truncate(25) }}
            </span>
              <i v-if="this.$route.name === 'ReportsNps'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div  v-if="dropdown === 1"
                  @click="goRouter('ReportsTickets')"
                  :class="{'list_hover_active' : this.$route.name === 'ReportsTickets'} && [0,1].includes(me.data.role_key) ? 'pb-3' : 'pb-4'"
                  class="animated--fade-in list-group-item list_hover  cursor_pointer d-flex justify-content-between text-decoration-none">
              <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
                {{ getTranslations('expression_106') }}
              </span>
              <i v-if="this.$route.name === 'ReportsTickets'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div  v-if="dropdown === 1 && me.data.role_key > 0"
                  @click="goRouter('ReportsChatbot')"
                  :class="{'list_hover_active' : this.$route.name === 'ReportsChatbot'}"
                  class="animated--fade-in list-group-item list_hover  cursor_pointer pb-4 d-flex justify-content-between text-decoration-none">
              <span class="ellipsis"><i class="bx bx-minus pr-2"></i>
                {{ getTranslations('expression_106') }}
              </span>
              <i v-if="this.$route.name === 'ReportsChatbot'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div v-if="me.data.role_key > 0" @click="goRouter('Users')"
                 :class="{'list_hover_active' : this.$route.name === 'Users' || this.$route.name === 'User'}"
                 class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bxs-group pr-3"></i><span class="ellipsis">{{ getTranslations('expression_82') }}</span>
              </div>
              <i v-if="this.$route.name === 'Users' || this.$route.name === 'User'"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div v-if="configs.data.partner.owner === 1" @click="openUrl(configs.url_docs_beecrm)"
                 class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bx-info-circle pr-3"></i><span class="ellipsis">{{ getTranslations('expression_134') }}</span>
              </div>
              <i v-if="false"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>

            <div @click="logoutUser"
                 class="list-group-item list_hover cursor_pointer d-flex align-items-center justify-content-between text-decoration-none">
              <div class="d-flex align-items-center">
                <i class="bx bx-log-in-circle pr-3"></i><span class="ellipsis">{{ getTranslations('expression_37') }}</span>
              </div>
              <i v-if="false"
                 class="animated--grow-in bx bx-chevron-right bx-xs"></i>
            </div>
          </ul>
        </div>

        <div v-if="true" class="row pt-4 pb-2" style="height: 1px; position: inherit; bottom: 0; width: 100%;">
        </div>

        <div v-if="false" class="row pt-4 pb-4" style="position: inherit; bottom: 0; width: 100%;">
          <div class="col px-0 text-center">
            <div @click="setUser" class="btn d-flex align-items-center rounded-0" style="justify-content: center;">
              <i class="bx bxs-landmark pr-3"></i>
              <div>
                LGPD
              </div>
            </div>
          </div>
          <div class="col px-0 text-center">
            <div @click="setUser" class="btn d-flex align-items-center rounded-0" style="justify-content: center;">
              <i class="bx bx-info-circle pr-3"></i>
              <div>
                {{ getTranslations('expression_134') }}
              </div>
            </div>
          </div>
          <div class="col px-0 text-center">
            <div @click.stop="logoutUser" class="btn d-flex align-items-center rounded-0" style="justify-content: center;">
              <i class="bx bx-log-out pr-3"></i>
              <div>
                {{ getTranslations('expression_37') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
  name: "MenuMobile",
  computed: {
    ...mapState(['configs', 'me']),
    ...mapGetters(['getTranslation'])
  },
  data(){
    return {
      dropdown: null
    }
  },
  methods: {
    ...mapActions(['logoutUser']),
    closeMenu(){
      this.configs.menu_mobile = false
    },
    goRouter(payload){
      if (this.$route.name !== payload){
        this.$router.push({name: `${payload}`})
      }
      setTimeout(()=> {
        this.closeMenu()
      }, 200)
    },
    openUrl(payload){
      window.open(payload, "_blank");
    },
    setUser() {
      window.localStorage.setItem("user_id", this.me.data.id)
      if (this.$route.name !== 'User'){
        this.$router.push({name: "User"});
      }
      setTimeout(()=> {
        this.closeMenu()
      }, 200)
    },
    setDropdown(paylaod){
      this.dropdown = paylaod === this.dropdown ? null : paylaod
    }
  }
}
</script>

<style scoped>
.list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.list-group-item:last-child {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
